import { render } from "./FR_form.vue?vue&type=template&id=56f0f406"
import script from "./FR_form.vue?vue&type=script&lang=js"
export * from "./FR_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__